<template>
	<header class="header">
		<!-- 头部导航 -->
		<div class="m-header-nav">
			<div class="nav">
				<div class="right">
					<router-link :to="{name: 'Problem'}">
						<div class="item">常见问题</div>
					</router-link>
					<router-link :to="{name: 'Serve'}">
						<div class="item">服务条款</div>
					</router-link>
					<router-link :to="{name: 'Company'}">
						<div class="item">关于我们</div>
					</router-link>
				</div>
			</div>
		</div>
		
		<!-- logo -->
		<div class="m-header-search">
			<router-link to="/">
				<div class="m-header-logo-box">
					<img class="m-header-logo" src="../assets/images/logo.png" alt="陌陌回收">
					<div class="m-header-company">
						<p class="name">陌陌回收</p>
						<p class="tag">买|卖|服|务|平|台</p>
					</div>
				</div>
			</router-link>
		</div>
		
		<!-- 导航栏 -->
		<nav class="el-nav">
			<router-link to="/">
				<div class="m-nav-item active">旧机回收</div>
			</router-link>
			<div class="m-item-QR">
				<div class="m-nav-QR">微信公众号</div>
				<div class="transition-box">
					<div class="QR-box">
						<img class="QR-code" src="../assets/images/wechat_QR.jpg" alt="陌陌回收">
						<div class="QR-text">扫码关注有礼</div>
					</div>
				</div>
			</div>
		</nav>
	</header>
</template>

<script>
export default{
	data(){
		return {
			
		}
	},
	
	methods:{
		
	}
}
</script>

<style scoped>
a{
	text-decoration: none;
}

.m-header-nav a{
	color: #999;
}

.m-header-nav a:hover{
	color: #3C78EB;
}

.header{
	background-color: #fff;
}

.m-header-nav{
	width: 100vw;
	background-color: #f8f9fb;
	
}

.m-header-nav .nav{
	width: 1226px;
	margin: 0 auto;
	display: flex;
	justify-content: flex-end;
	color: #999;
	font-size: 14px;
}

.m-header-nav .right{
	display: flex;
}

.m-header-nav .item{
	width: 78px;
	height: 44px;
	line-height: 42px;
}

.m-header-search{
	width: 1226px;
	margin: 20px auto 0;
}

.m-header-search .m-header-logo-box{
	display: flex;
}

.m-header-search .m-header-logo{
	width: 80px;
	height: 80px;
}

.m-header-search .m-header-company{
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-left: 10px;
}

.m-header-search .m-header-company .name{
	color: #282828;
	font-size: 40px;
	font-weight: bold;
	letter-spacing: 2px;
	padding: 0;
	margin: 0;
}

.m-header-search .m-header-company .tag{
	color: #282828;
	font-size: 18px;
	padding: 0;
	margin: 0;
	letter-spacing: 3px;
}

.el-nav{
	width: 1226px;
	margin: 30px auto 0;
	display: flex;
}

.el-nav .m-nav-item,
.el-nav .m-nav-QR{
	width: 234px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	color: #282828;
	transition: all 0.05s;
	cursor: pointer;
}

.el-nav .transition-box{
	height: 0;
	overflow: hidden;
	transition: all 0.1s;
	position: absolute;
	z-index: 99;
}

.el-nav .QR-box{
	width: 234px;
	height: 200px;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #fff;
}

.el-nav .transition-box .QR-code{
	width: 170px;
	height: 170px;
}

.el-nav .transition-box .QR-text{
	color: #ff7ca7;
	margin-top: 5px;
	font-size: 14px;
}

.m-nav-QR:hover,
.m-nav-item:hover{
	background-color: #3C78EB;
	color: #fff !important;
}

.m-nav-QR:hover+.transition-box{
	height: 200px !important;
}

.active{
	background-color: #3C78EB;
	color: #fff !important;
}
</style>